<div class="content-container margin-bottom">
  <section role="region" aria-label="Users controls" class="controls">
    <h2 class="visually-hidden">User controls</h2>
    <div class="left-controls">
      <div class="filters">
        <app-filter-editor [formControl]="filterControl"
          [chips]="['name', 'email', 'hawkid', 'univid', 'dept', 'dept(owners)', 'dept.key', 'reportsto.hawkid', 'adsource', 'role',
          'jobtitle','jobcode', 'orgid', 'hrdept', 'hrsubdept', 'paygrade', 'effort.key', 'effort',
          'former.jobtitle', 'former.jobcode', 'former.orgid', 'former.hrdept', 'former.hrsubdept', 'former.paygrade']"
          [flags]="['archived', 'deprovisioned']" [selectedFilters]="(selectedFilters | async) || []"
          [chipPossVals]="chipPossVals" [chipHelpers]='chipHelpers'
          label="Filter users by attribute or plain text" (filterChange)="filterChange($event)" class="filter-editor">
        </app-filter-editor>

        <button mat-stroked-button (click)="selectedFilters.next([])">
          <mat-icon class="material-symbols-outlined">clear</mat-icon>
          Clear
        </button>
      </div>
    </div>

    <div class="right-controls">
      <mat-form-field>
        <mat-label>Displayed Columns</mat-label>
        <mat-select [formControl]="chosenColumns" multiple>
          @for (col of availableColumns | keyvalue: originalOrder; track col) {
          <mat-option [value]="col.key">{{col.value}}</mat-option>
          }
          <button mat-raised-button (click)="resetColumns()" class="reset-col-defaults">Reset to defaults</button>
        </mat-select>
      </mat-form-field>
    </div>
  </section>
</div>

<div class="content-container working-with margin-sm-bottom">
  @if (group) {
  <div class="working-with-item">
  <div class="mode-helper arrow-box">
    <button mat-icon-button (click)='clearFilter("dept.key")' title="Remove department filter from filters." aria-label="Remove department filter">
      <mat-icon>cancel</mat-icon>
    </button>
    <span>Working with department: <b>'{{group.name}}'</b></span>
  </div>
  <button mat-stroked-button class="specific-action" (click)="openAddUsersDialog('group')"
    [attr.aria-label]="'Add owners to department ' + group.name">
    <mat-icon>add</mat-icon>Add owners
  </button>
  </div>
  }
  @if (project) {
  <div class="working-with-item">
  <div class="mode-helper arrow-box">
    <button mat-icon-button (click)='clearFilter("project.key")' title="Remove project filter from filters.">
      <mat-icon>cancel</mat-icon>
    </button>
    <span>Working with project: <b>'{{project.title}}'</b> from <b>'{{project.effort.title}}'</b></span>
  </div>
  <button mat-stroked-button class="specific-action" (click)="openAddUsersDialog('project')"
    [attr.aria-label]="'Add users to project ' + project.title">
    <mat-icon>add</mat-icon>Add users
  </button>
  </div>
  }
  @if (effort) {
    <div class="working-with-item">
    <div class="mode-helper arrow-box">
    <button mat-icon-button (click)='clearFilter("effort.key")'
        title="Remove effort filter from filters.">
        <mat-icon>cancel</mat-icon>
    </button>
    <span>Working with effort: <b>'{{effort.title}}'</b></span>
    </div>
    <button mat-stroked-button class="specific-action" (click)="openAddUsersDialog('effort')"
      [attr.aria-label]="'Add owners to effort ' + effort.title">
      <mat-icon>add</mat-icon>Add owners
    </button>
    </div>
  }
</div>

<section role="region" aria-label="Users table entries" class='projects-table-container'>
    <h2 class="visually-hidden">User table entries</h2>
  <!-- <div class="col-removal-area" cdkDropList (cdkDropListDropped)="hideColumn($event)" #hideList="cdkDropList" [cdkDropListConnectedTo]='[mainList]'>
    <mat-icon>delete_outlined</mat-icon>
    Hide column
  </div> -->
  <table mat-table [dataSource]="dataSource" matSort matSortDirection="asc" matSortActive="fullname" scope="col"
    cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" #mainList="cdkDropList"
    (cdkDropListDropped)="reorderColumns($event)">

    <!-- Project Title Column -->
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef scope="col" id="username" cdkDrag>
        <span mat-sort-header>Hawk Id</span>
        <!-- <div *cdkDragPreview class="col-drag-preview"> Hawk Id </div> -->
      </th>
      <td mat-cell *matCellDef="let user" [class.struck]="user.isDeleted"> {{ user.hawkId }} </td>
    </ng-container>

    <!-- Effort Title Column -->
    <ng-container matColumnDef="fullname">
      <th mat-header-cell *matHeaderCellDef scope="col" id="fullname" cdkDrag><span mat-sort-header> Name </span></th>
      <td mat-cell *matCellDef="let user" [class.struck]="user.isDeleted">
        {{ user.displayName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef scope="col" id="email" cdkDrag><span mat-sort-header> Email </span></th>
      <td mat-cell *matCellDef="let user" [class.struck]="user.isDeleted">
        {{ user.email }}
      </td>
    </ng-container>

    <ng-container matColumnDef="reportsto">
      <th mat-header-cell *matHeaderCellDef scope="col" id="reportsto" cdkDrag><span mat-sort-header> Reports To </span>
      </th>
      <td mat-cell *matCellDef="let user">
        @if (user.reportsTo) {
        <a [routerLink]="['/users']" [queryParams]="{ 'filter.reportsto.hawkid': user.reportsTo.hawkId }"
          title="View all who report to this person.">
          {{ user.reportsTo.displayName }} ({{ user.reportsTo.hawkId }})
        </a>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef scope="col" id="edit" cdkDrag><span> User Actions </span></th>
      <td mat-cell *matCellDef="let user">
        <button mat-icon-button [routerLink]="['/projects']" [queryParams]="{ 'filter.member.hawkid': user.hawkId }"
          title="View projects associated with this user."><mat-icon
            class="material-symbols-outlined">group_search</mat-icon></button>
        <button mat-icon-button (click)="openEditDialog(user)" title="View or edit certain attributes associated with this user.">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="openBatchEditDialog(user)" title="Bulk add or remove dept, effort, and project associations with this user.">
          <mat-icon class="material-symbols-outlined">person_play</mat-icon>
        </button>
        <!-- <button mat-icon-button (click)="deleteProject(project)"><mat-icon>delete</mat-icon></button> -->
      </td>
    </ng-container>

    <ng-container matColumnDef="job-title">
      <th mat-header-cell *matHeaderCellDef scope="col" id="job-title" cdkDrag><span mat-sort-header> Job Title </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.jobTitle }}
      </td>
    </ng-container>

    <ng-container matColumnDef="former-job-title">
      <th mat-header-cell *matHeaderCellDef scope="col" id="former-job-title" cdkDrag><span mat-sort-header> Former Job Title </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.formerJobTitle }}
      </td>
    </ng-container>

    <ng-container matColumnDef="job-code">
      <th mat-header-cell *matHeaderCellDef scope="col" id="job-code" cdkDrag><span mat-sort-header> Job Code </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.jobCode }}
      </td>
    </ng-container>

    <ng-container matColumnDef="former-job-code">
      <th mat-header-cell *matHeaderCellDef scope="col" id="former-job-code" cdkDrag><span mat-sort-header> Former Job Code </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.formerJobCode }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dept-code">
      <th mat-header-cell *matHeaderCellDef scope="col" id="dept-code" cdkDrag><span mat-sort-header> Dept Code </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.departmentCode }}
      </td>
    </ng-container>

    <ng-container matColumnDef="former-dept-code">
      <th mat-header-cell *matHeaderCellDef scope="col" id="former-dept-code" cdkDrag><span mat-sort-header> Former Dept Code </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.formerDepartmentCode }}
      </td>
    </ng-container>

    <ng-container matColumnDef="subdept-code">
      <th mat-header-cell *matHeaderCellDef scope="col" id="subdept-code" cdkDrag><span mat-sort-header> Subdept Code
        </span></th>
      <td mat-cell *matCellDef="let user">
        {{ user.subdeptCode }}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="former-subdept-code">
      <th mat-header-cell *matHeaderCellDef scope="col" id="former-subdept-code" cdkDrag><span mat-sort-header> Former Subdept Code
        </span></th>
      <td mat-cell *matCellDef="let user">
        {{ user.formerSubdeptCode }}
      </td>
    </ng-container>

    <ng-container matColumnDef="org-id">
      <th mat-header-cell *matHeaderCellDef scope="col" id="org-id" cdkDrag><span mat-sort-header> Org Id </span></th>
      <td mat-cell *matCellDef="let user">
        {{ user.orgId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="former-org-id">
      <th mat-header-cell *matHeaderCellDef scope="col" id="former-org-id" cdkDrag><span mat-sort-header> Former Org Id </span></th>
      <td mat-cell *matCellDef="let user">
        {{ user.formerOrgId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="pay-grade">
      <th mat-header-cell *matHeaderCellDef scope="col" id="pay-grade" cdkDrag><span mat-sort-header> Pay Grade </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.payGrade }}
      </td>
    </ng-container>

    <ng-container matColumnDef="former-pay-grade">
      <th mat-header-cell *matHeaderCellDef scope="col" id="former-pay-grade" cdkDrag><span mat-sort-header> Former Pay Grade </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.formerPayGrade }}
      </td>
    </ng-container>

    <ng-container matColumnDef="pop-source">
      <th mat-header-cell *matHeaderCellDef scope="col" id="pop-source" cdkDrag><span mat-sort-header> AD Source </span>
      </th>
      <td mat-cell *matCellDef="let user">
        {{ user.popSource }}
      </td>
    </ng-container>

    <ng-container matColumnDef="leave">
      <th mat-header-cell *matHeaderCellDef scope="col" style="width: 2em" id="leave" cdkDrag><span mat-sort-header>
          Leave </span></th>
      <td mat-cell *matCellDef="let user" style="width: 2em;">
        @if (user.excludeFromLeaveExport) {
        <mat-icon (click)="openEditDialog(user)" style="cursor: pointer">block</mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="finalLeave">
      <th mat-header-cell *matHeaderCellDef scope="col" style="width: 2em" id="leave" cdkDrag><span mat-sort-header>
          Final Leave </span></th>
      <td mat-cell *matCellDef="let user" style="width: 2em;">
        @if (user.includeForFinalLeave) {
        <mat-icon (click)="openEditDialog(user)" style="cursor: pointer">check</mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="univid">
      <th mat-header-cell *matHeaderCellDef scope="col" id="univid" cdkDrag><span mat-sort-header> University Id </span>
      </th>
      <td mat-cell *matCellDef="let user" [class.struck]="user.isDeleted">
        {{ user.universityId ?? "N/A"}}
      </td>
    </ng-container>

    <ng-container matColumnDef="emp-number">
      <th mat-header-cell *matHeaderCellDef scope="col" id="emp-number" cdkDrag><span mat-sort-header> Employee Number
        </span></th>
      <td mat-cell *matCellDef="let user" [class.struck]="user.isDeleted">
        {{ user.employeeNumber ?? "N/A"}}
      </td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef scope="col" id="created" cdkDrag><span mat-sort-header> Created </span></th>
      <td mat-cell *matCellDef="let user">
        {{ user.created | date: 'hh:mma, MMM dd, yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="tks-begin-date">
      <th mat-header-cell *matHeaderCellDef scope="col" id="tks-begin-date" cdkDrag><span mat-sort-header> TKS Begin Date </span></th>
      <td mat-cell *matCellDef="let user">
        {{ user.tksBeginDate | date: 'hh:mma, MMM dd, yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="last-updated">
      <th mat-header-cell *matHeaderCellDef scope="col" id="last-updated" cdkDrag><span mat-sort-header> Last Updated
        </span></th>
      <td mat-cell *matCellDef="let user">
        {{ user.lastUpdated | date: 'hh:mma, MMM dd, yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef scope="col" id="role" cdkDrag><span mat-sort-header> Role </span></th>
      <td mat-cell *matCellDef="let user" [class.struck]="user.isDeleted">
        {{ roleDescription(user.userRoles[0]?.roleId) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="group-specific-tools">
      <th mat-header-cell *matHeaderCellDef class='group-specific-tools' scope="col" id="group-specific-tools" cdkDrag>
        <span>Dept Actions</span></th>
      <td mat-cell *matCellDef="let user" class="group-specific-tools">
        @if (group) {
        <div class="row-tools">
          <button mat-icon-button (click)="removeUserFromGroup(user, group)" title="Remove user from active group.">
            <mat-icon>group_remove</mat-icon>
          </button>
        </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="effort-specific-tools">
      <th mat-header-cell *matHeaderCellDef class='effort-specific-tools' scope="col" id="effort-specific-tools" cdkDrag>
        <span>Effort Actions</span></th>
      <td mat-cell *matCellDef="let user" class="effort-specific-tools">
        @if (effort) {
        <div class="row-tools">
          <button mat-icon-button (click)="removeUserFromEffort(user, effort)" title="Remove user from active effort.">
            <mat-icon>group_remove</mat-icon>
          </button>
        </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="project-specific-tools">
      <th mat-header-cell *matHeaderCellDef class='project-specific-tools' scope="col" id="project-specific-tools"
        cdkDrag><span>Project Actions</span></th>
      <td mat-cell *matCellDef="let user" class="project-specific-tools">
        @if (project) {
        <div class="row-tools">
          <button mat-icon-button (click)="removeUserFromProject(user, project)"
            title="Remove user from active project.">
            <mat-icon>group_remove</mat-icon>
          </button>
        </div>
        }
      </td>
    </ng-container>

    <!-- header no results message -->
    <ng-container matColumnDef='group-or-no-results'>
      <td mat-footer-cell *matFooterCellDef [attr.colspan]='displayedColumns.length'
        class='whole-row-no-results whole-row-helper'>
        @if (! (isLoading | async)) {
        <div>
          @if (dataSource.data.length == 0) {
          <p>
            @if (dataSource.data.length == 0) {
            <span>No users found</span>
            }
            @if (filters?.length) {
            <button mat-flat-button color="accent" (click)='selectedFilters.next([])'>Clear Filter</button>
            }
          </p>
          }
        </div>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr [hidden]='dataSource.data.length > 0' mat-footer-row *matFooterRowDef="['group-or-no-results']; sticky: true"
      class="group-or-no-results"></tr>
  </table>
  <div class="loading-data" [class.showing]="isLoading | async">
    <mat-spinner></mat-spinner>
  </div>
</section>

<section role="region" aria-label="Users table pagination" class="bottom-tools">
    <h2 class="visually-hidden">Users table pagination</h2>
  <mat-paginator [pageSizeOptions]="[10, 15, 20, 30, 50, 100]" showFirstLastButtons [pageSize]="10"
    [length]="totalUsers">
  </mat-paginator>
</section>
